import {format, parseISO} from "date-fns";
import {toZonedTime, fromZonedTime, format as formatTz} from "date-fns-tz";

const LONDON_TZ = "Europe/London";

// Format for display: "13 May 2025, 23:41 BST"
export function formatBritishTime(isoString: string): string {
  if (!isoString) return "";
  const date = typeof isoString === "string" ? parseISO(isoString) : isoString;
  return formatTz(date, "dd MMM yyyy, HH:mm z", {timeZone: LONDON_TZ});
}

// For <input type="datetime-local" />: "2025-05-13T23:41"
export function isoToBritishInput(isoString: string): string {
  if (!isoString) return "";
  const date = toZonedTime(parseISO(isoString), LONDON_TZ);
  return format(date, "yyyy-MM-dd'T'HH:mm");
}

// Convert local picker value (e.g. "2025-05-13T23:41") to ISO UTC string
export function britishInputToIso(localValue: string): string {
  if (!localValue) return "";
  const zonedDate = fromZonedTime(localValue, LONDON_TZ);
  return zonedDate.toISOString();
}
